import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    style: {"box-shadow":"none"},
    class: "d-flex flex-column"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { stye: "overflow-y: auto; height:75vh;" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("h2", null, "Réglages de la période de votre prévisionnel", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" Nombre d'exercices du prévisionnel ")
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.parameters.periodsNumber,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parameters.periodsNumber) = $event)),
                    items: _ctx.selectPeriodsNumber,
                    "item-value": "id",
                    "single-line": "",
                    required: "",
                    label: "Nombre d'exercices",
                    "hide-details": "auto",
                    density: "compact",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("h2", null, "Délais de règlement", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createElementVNode("h4", null, "Clients", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.parameters.paymentDelayClient,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parameters.paymentDelayClient) = $event)),
                    items: _ctx.paymentDelays,
                    "item-value": "id",
                    "single-line": "",
                    required: "",
                    label: "Temps que met le client à vous payer",
                    "hide-details": "auto",
                    density: "compact",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("h4", null, "Fournisseur sur charge fixe", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.parameters.paymentDelaySupplierPurchase,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.parameters.paymentDelaySupplierPurchase) = $event)),
                    items: _ctx.paymentDelays,
                    "item-value": "id",
                    "single-line": "",
                    required: "",
                    label: "Temps que vous mettez à payer un fournisseur",
                    "hide-details": "auto",
                    density: "compact",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createElementVNode("h4", null, "Fournisseur sur charge variable", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.parameters.paymentDelaySupplierCosts,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parameters.paymentDelaySupplierCosts) = $event)),
                    items: _ctx.paymentDelays,
                    "item-value": "id",
                    "single-line": "",
                    required: "",
                    label: "Temps que vous mettez à payer un fournisseur",
                    "hide-details": "auto",
                    density: "compact",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("h2", null, "Valeurs moyennes de TVA", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("h4", null, "TVA sur activité", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.vatSell,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parameters.vatSell) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createElementVNode("h4", null, "TVA sur charges fixes", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.vatPurchase,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.parameters.vatPurchase) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createElementVNode("h4", null, "TVA sur charges variables", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.vatCost,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.parameters.vatCost) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("h4", null, "TVA sur immobilisations", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.vatImmo,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.parameters.vatImmo) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[23] || (_cache[23] = [
                  _createElementVNode("h2", null, "Charges salariales pour un employé", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createElementVNode("h4", null, "Taux de charges salariales (employé)", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.wagesTax,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.parameters.wagesTax) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("h4", null, "Taux de charges patronales (employé)", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.employerTax,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.parameters.employerTax) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("h4", null, "Taux de charges globales (dirigeant)", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_text_field_filled, {
                    label: "%",
                    "single-line": "",
                    "hide-details": "auto",
                    modelValue: _ctx.parameters.globalTax,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.parameters.globalTax) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createElementVNode("h2", null, "Financement", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createElementVNode("h4", null, "Mode d'assurance emprunteur", -1)
                ])),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "6",
                class: "d-flex mb-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.parameters.loanInsuranceMode,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.parameters.loanInsuranceMode) = $event)),
                    items: _ctx.loanInsuranceModes,
                    "item-value": "id",
                    "single-line": "",
                    required: "",
                    label: "Mode d'assurance emprunteur",
                    "hide-details": "auto",
                    density: "compact",
                    "item-title": (item) => item.name
                  }, null, 8, ["modelValue", "items", "item-title"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}